import React from 'react';

const LockIcon = () => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M11.3333 5.33268V3.99935C11.3333 2.13268 9.86659 0.666016 7.99992 0.666016C6.13325 0.666016 4.66659 2.13268 4.66659 3.99935C4.66659 4.33268 4.66659 5.33268 4.66659 5.33268H3.33325V13.3327H12.6666V5.33268H11.3333ZM7.99992 10.666C7.26659 10.666 6.66659 10.066 6.66659 9.33268C6.66659 8.59935 7.26659 7.99935 7.99992 7.99935C8.73325 7.99935 9.33325 8.59935 9.33325 9.33268C9.33325 10.066 8.73325 10.666 7.99992 10.666ZM9.99992 5.33268H5.99992C5.99992 5.33268 5.99992 4.33268 5.99992 3.99935C5.99992 2.86602 6.86659 1.99935 7.99992 1.99935C9.13325 1.99935 9.99992 2.86602 9.99992 3.99935V5.33268Z' />
		</svg>
	);
};

export default LockIcon;
